import { PolylineCollection, Viewer } from "cesium"

export default class PolylineLayer {

    constructor() {
        this.lines = {}
    }

    add(polyline, id) {
        polyline.id = id
        let line = this.lineCollection.add(polyline)
        this.lines[id] = line
    }

    remove(polyline) {
        this.lineCollection.remove(polyline)
    }

    clear() {
        this.lineCollection.removeAll()
    }

    removeById(id) {
        if(Object.keys(this.lines).includes(id)) {
            this.lineCollection.remove(this.lines[id])
            delete this.lines[id]
        }
    }
    /**
     * 
     * @param {Viewer} viewer 
     */
    addTo(primitives, id) {
        this.lineCollection = primitives.add(new PolylineCollection())
        this.lineCollection.metadata = {id: id}
        primitives.raiseToTop(this.lineCollection)
        this.primitives = primitives
    }

    destory() {
        this.clear()
        this.primitives.remove(this.lineCollection)
    }
}